/* ============================================================
   pltx2-fitness-player.js
   §1 Pilatix App — Hero video player
   - Picks the right video source by viewport width (mobile vs desktop)
   - Forces autoplay (muted, playsinline — required for iOS)
   - Single play/pause toggle (Apple-faithful glyph swap)
   - Per-instance: scoped via data-pltx2-fp-id on the section root,
     so multiple players on the same page work independently.
   ============================================================ */
(function () {
  'use strict';

  function setupPlayer(root) {
    var video    = root.querySelector('[data-pltx2-fp-video]');
    var playBtn  = root.querySelector('[data-pltx2-fp-playpause]');
    if (!video) return;

    // ---- Pick source for the current viewport (run once at init) ----
    var desktopUrl = root.getAttribute('data-video-desktop') || '';
    var mobileUrl  = root.getAttribute('data-video-mobile')  || desktopUrl;
    var pickedUrl  = (window.innerWidth < 735 && mobileUrl) ? mobileUrl : desktopUrl;
    if (pickedUrl) {
      // set on a <source> child if present, else directly on the video element
      var sourceEl = video.querySelector('source');
      if (sourceEl) sourceEl.setAttribute('src', pickedUrl);
      else          video.setAttribute('src', pickedUrl);
      video.load();
    }

    // ---- Force autoplay (muted required by browsers) ----
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('playsinline', 'true');
    video.setAttribute('webkit-playsinline', 'true');

    function forcePlay() {
      var p = video.play();
      if (p && p.catch) p.catch(function () { setTimeout(forcePlay, 200); });
    }
    forcePlay();
    video.addEventListener('loadeddata',     forcePlay);
    video.addEventListener('loadedmetadata', forcePlay);
    video.addEventListener('canplay',        forcePlay);
    // iOS — first user touch unlocks playback if it was blocked
    document.addEventListener('touchstart', forcePlay, { once: true, passive: true });

    // ---- Play/pause toggle ----
    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (video.paused) video.play();
        else              video.pause();
      });
      video.addEventListener('play', function () {
        playBtn.classList.add('is-playing');
        playBtn.setAttribute('aria-label', playBtn.getAttribute('data-label-pause') || 'Pause video');
      });
      video.addEventListener('pause', function () {
        playBtn.classList.remove('is-playing');
        playBtn.setAttribute('aria-label', playBtn.getAttribute('data-label-play') || 'Play video');
      });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-pltx2-fp-root]');
    for (var i = 0; i < roots.length; i++) setupPlayer(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor block-changed events so changes preview live
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pltx2-fp-root]');
    if (root) setupPlayer(root);
  });
})();
